import BaseService from "../BaseService";
import http from "../HttpService";
import { API_BASE_URL_ENV } from "helpers/common";

const apiEndpoint = API_BASE_URL_ENV() + "/admin/user/clients";
const apiDropDownEndpoint = API_BASE_URL_ENV() + "/admin/user/dropdown/Client";
const exportApi =API_BASE_URL_ENV() + "/admin/user/clients?seller=1&export=1"

export default class extends BaseService {
    constructor() {
        super(apiEndpoint);
    }
    toggleStatus=(id)=>{ 
        return   http.get(`${API_BASE_URL_ENV()}/admin/user/toggle-activation/Client/${id}`)   
       }
   
       getDropDown=()=>{
        return  http.get(apiDropDownEndpoint) 
      }
      deleteResales=(id)=>{
        return   http.delete(`${API_BASE_URL_ENV()}/admin/user/client/resale/${id}`)
       }


       getExportUrl = (active,location,searchWord) => {
        const obj = JSON.parse(localStorage.getItem("auth"))
        let url = `${exportApi}&token=${obj.access_token}`;
        if (active != 'all')  url =url + `&status=${active === "active" ? 1 : 0}`;
        if (searchWord.trim().length)  url =url + `&keyword=${searchWord}`;
        if (location) url =url + `&location=${location}`
        return url
    }
}
